import { useCallback, useState } from "react";

const getValueOfObj = (obj, key) => {
  const splitKey = key.includes(".") ? key.split(".") : [key];
  let value = obj;
  for (let key of splitKey) {
    value = value[key];
  }
  return value;
};
export const getUniques = (arr, key = "id") => {
  return arr
    .map((item) => {
      return getValueOfObj(item, key);
    })
    .filter((value, index, self) => self.indexOf(value) === index)
    .map((item) => {
      return {
        key: item,
        ...arr.find((s) => {
          return getValueOfObj(s, key) === item;
        }),
      };
    });
};
const useToggleFields = (intialField) => {
  const [fields, setFields] = useState(intialField ? [intialField] : []);
  const addField = useCallback((field, key) => {
    setFields((fields) => {
      if (!key) return fields.concat(field);
      const allFields = fields.concat(field);

      return getUniques(allFields, key);
    });
  }, []);
  const removeField = useCallback((field, key) => {
    if (typeof field !== "object" && key) {
      return setFields((prev) => {
        const newFileds = [...prev];
        return newFileds.filter((_field) => {
          return _field !== field;
        });
      });
    } else if (typeof field === "object") {
      setFields((prev) => prev.filter((_field) => _field !== field));
    }
  }, []);
  const updateField = useCallback((update, fieldValue, key) => {
    return setFields((prev) => {
      const newFileds = [...prev];
      const fieldIdx = newFileds.findIndex((_field) => {
        return _field[key] === fieldValue;
      });
      if (fieldIdx === -1) return prev;
      newFileds.splice(fieldIdx, 1, {
        ...prev[fieldIdx],
        ...update,
      });
      return newFileds;
    });
  }, []);
  return { fields, addField, removeField, updateField, setFields };
};

export default useToggleFields;
